import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const eventosModule = {
	state: {
		eventos : ''
	},
	getters: {  
        getEventos : state => state.eventos
	},
	actions: {
        requestEventos({commit, dispatch}){
            return new Promise((resolve, reject) => {

				axios.get("/api/Alumno/dameNumEventos").then( result => {
					if(result.data.status == 0){	
						let data = {
							max: result.data.datos.numPaginas,
							page: 1
						};
							dispatch('requestMoreEventos', data);
					}else{
						commit('setError',result.data.status)
					}

				}).catch(error => {
					
				});  
			});	
		},
		requestMoreEventos({ commit, dispatch }, data) {

            return new Promise((resolve, reject) => {

				if (data.page <= data.max) {

                    axios.get('/api/Alumno/dameEventos/' + data.page).then(result => {

                        if (result.data.status == 0) {
							commit('addEventos', result.data.datos.eventos);
							data.page++;
                            dispatch('requestMoreEventos', data);
                            resolve(true);
                        } else {
                            commit('setError', result.data.status)
                            reject(false);
                        }

                    }).catch(error => {

					});
				}
            });
        },
        requestEvento({commit}, slug){
            return new Promise((resolve, reject) => {

				axios.get('/api/Alumno/detalleEvento/'+slug).then( result => {
                    if(result.data.status == 0){
                        resolve(result.data.datos);
                    }else{
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
                    reject(false);
				});  
			});	
		},
		inscripcionEvento({commit,dispatch}, data){
            return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/inscribeEnEvento',data).then( result => {
                    if(result.data.status == 0){
						commit('setError', 600);
						commit('eraseEventos');
						dispatch('requestEventos');
						resolve(true);
                    }else{
						commit('setError', result.data.status)
						resolve(false);
					}
				}).catch(error => {
                    reject(false);
				});  
			});	
		},
		subirMemoriaEvento({commit,dispatch}, data){
            return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/subeMemoriaEvento/'+data.urlAcceso,data).then( result => {
                    if(result.data.status == 0){
						commit('setError', 604);
						commit('eraseEventos');
						dispatch('requestEventos');
						resolve(true);
                    }else{
						commit('setError', result.data.status)
						resolve(false);
					}
				}).catch(error => {
                    reject(false);
				});  
			});	
        }
	},
	mutations: {
        addEventos(state, eventos){
			if(!!!state.eventos){
				state.eventos = eventos;
			}else{
				state.eventos = state.eventos.concat(eventos);
			}
		},
		eraseEventos(state){
			state.eventos = [];
		}
	}
}

export default eventosModule;


// WEBPACK FOOTER //
// ./src/store/eventosModule.js